import { IAction } from "store";
import { DealAction } from "../../actions";
import { IInvestor, InvestorWithBank } from "../../types";
import { reducer } from "../index";

reducer.createHandler(
  DealAction.GetInvestorsSuccess,
  (state, { payload }: IAction<InvestorWithBank[]>) => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      investors: payload,
    },
  })
);

reducer.createHandler(
  DealAction.CreateInvestorSuccess,
  (state, { payload }: IAction<IInvestor>) => {
    return {
      ...state,
      dealModule: {
        ...state.dealModule,
        investors: [
          ...state.dealModule.investors,
          { ...payload, bank_details: null },
        ],
      },
    };
  }
);

reducer.createHandler(
  DealAction.UpdateInvestorSuccess,
  (state, { payload }: IAction<InvestorWithBank>) => {
    return {
      ...state,
      dealModule: {
        ...state.dealModule,
        investors: [...state.dealModule.investors].map((investor) => {
          if (investor.id === payload.id) {
            return {
              ...investor,
              ...payload,
            };
          }
          return investor;
        }),
      },
    };
  }
);

reducer.createHandler(
  DealAction.DeleteInvestorSuccess,
  (state, { payload }: IAction) => {
    return {
      ...state,
      dealModule: {
        ...state.dealModule,
        investors: [...state.dealModule.investors].filter(
          (investor) => investor.id !== payload
        ),
      },
    };
  }
);
